import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import DivingDads from './DivingDads/DivingDads'
import Home from './Home/Home'
import Lab from './Lab/Lab'
import Layout from './Layout'
import RecipeParser from './RecipeParser/RecipeParser'
import Work from './Work/Work'
import WorkProject from './Work/WorkProject'

const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      {
        path: '/',
        element: <Home />
      },
      {
        path: '/work',
        element: <Work />
      },
      {
        path: '/work/:projectId',
        element: <WorkProject />
      },
      {
        path: '/lab',
        element: <Lab />
      },
      {
        path: '/diving-dads',
        element: <DivingDads />
      },
      {
        path: '/lab/recipe-parser',
        element: <RecipeParser />
      },
      {
        path: '/recipe-parser',
        element: <RecipeParser />
      }
    ]
  }
])

const App = () => {
  return <RouterProvider router={router} />
}

export default App
